var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',[_c('place-add',{attrs:{"business-id":_vm.$route.params.businessId},on:{"done":function($event){return _vm.$router.push({ name: 'system-business-edit', params: { id: _vm.$route.params.businessId } })}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }